import { Component } from '@angular/core';
import { IContext, primaryButton, label, table, iconButton, secondaryButton } from 'msteams-ui-styles-core'

import { MsTeamsContextProvider } from '../core/providers/msteamscontext.provider';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  actualUser: string;

  cssBtnPrimary: string;
  cssBtnSecondary: string;

  msTable;

  constructor(private _msTeamsContextProvider: MsTeamsContextProvider,
              private router: Router,
              private _route: ActivatedRoute) { }

  ngOnInit() {

    this._route.queryParamMap.subscribe(queryParams => {

      if (queryParams.get("userPrincipal")) {
        this.actualUser = queryParams.get("userPrincipal").toLowerCase();
      }
      else {
        this.router.navigate(['/access-denied']);
      }    

      console.log("userPrincipal:" + this.actualUser);
    })

    // Here is the magic.
    var context = this._msTeamsContextProvider.getContext();
     
    this.cssBtnPrimary = primaryButton(context);
    this.cssBtnSecondary = secondaryButton(context);
    this.msTable = table(context);
  }
    

  create() {
    this.router.navigate(['/new-request'], { queryParams: { userPrincipal: this.actualUser }});
  }

  myRequest() {
    this.router.navigate(['/my-team-request'], { queryParams: { userPrincipal: this.actualUser } });
  }
}
